export default [
  // 购物车页
  {
    path: '/shoppingcart',
    name: 'shoppingCart',
    meta: {
      type: 'page',
      title: '购物车',
      stParams: {}
    },
    component: () => import(/* webpackChunkName: 'shoppingcart' */ 'views/shopcart/list')
  },
  {
    path: '/shoppingcart/gather',
    name: 'shoppingcartGather',
    meta: {
      type: 'page',
      title: '优惠凑单'
    },
    component: () => import(/* webpackChunkName: 'gather' */ 'views/shopcart/gather')
  }
]
